export default {
  "agentApprovalHistory.title": "提现审批",
  "agentApprovalHistory.thead.index": "#序号",
  "agentApprovalHistory.thead.applyId": "申请ID",
  "agentApprovalHistory.thead.userno": "用户编号",
  "agentApprovalHistory.thead.email": "邮箱",
  "agentApprovalHistory.thead.statusDesc": "状态",
  "agentApprovalHistory.thead.applyTime": "申请时间",
  "agentApprovalHistory.thead.approvalTime": "审批时间",
  "agentApprovalHistory.thead.applyTimeFrom": "审批开始时间",
  "agentApprovalHistory.thead.applyTimeTo": "审批结束时间",
  "agentApprovalHistory.thead.operator": "操作人",
  "agentApprovalHistory.thead.action": "操作",
  "agentApprovalHistory.tooltip.copyUserNo": "复制用户ID",
  "agentApprovalHistory.tooltip.userDetails": "用户详细信息",
};
